import { FormMessageVariant } from '@aus-platform/design-system';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import React from 'react';

type CalloutProps = {
  title: string;
  items: string[];
  variant?: FormMessageVariant;
  className?: string;
};

export const Callout: React.FC<CalloutProps> = ({
  title,
  items,
  variant = FormMessageVariant.Info,
  className,
}) => {
  // Variables.
  const customClassname = classNames(
    'callout',
    `callout--${variant}`,
    className,
  );

  return (
    <div className={customClassname}>
      <div className="callout__title">{title}</div>

      {!isEmpty(items) && (
        <ul className="callout__list">
          {items.map((item, index) => (
            <li key={`callout-item-${index}`}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
